import localFont from 'next/font/local';

export const ChillaxFont = localFont({
  src: [{ path: './chillax-variable.ttf', weight: '600' }],
});

export const Chillax = ChillaxFont.style.fontFamily;
